import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import SpecialtySection from "@/components/site/SpecialtySection";
import Tarifs from "@/components/site/Tarifs";
import Creations from "@/components/site/Creations";
import PromoAutomne from "@/components/site/PromoAutomne";
import Authenticite from "@/components/site/Authenticite";
import About from "@/components/site/About";
import AproposDeMoi from "@/components/site/AproposDeMoi";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { CATEGORIES } from "@/data/site";

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.25,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        lenisRef.current = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    const scrollTo = (target) => {
        if (lenisRef.current) {
            lenisRef.current.scrollTo(target, { offset: -70, duration: 1.6 });
        }
    };

    return (
        <div
            data-testid="site-root"
            className="App relative min-h-screen bg-[#050505] text-white antialiased"
        >
            <div className="grain-overlay" aria-hidden="true" />
            <main>
                <Hero onScrollDown={() => scrollTo("#portraits")} />
                <Marquee />
                    
                <section className="relative overflow-hidden border-t border-[#D4AF37]/20 bg-[#050505] px-6 py-16 text-center">
                    <div className="mx-auto max-w-4xl">
                        <p className="mb-3 text-xs tracking-[0.3em] text-[#D4AF37]">
                            LE GARS DE LA PHOTO
                        </p>
                        <h2 className="mb-4 text-3xl font-light text-white md:text-4xl">
                            Le monde équestre
                        </h2>
                        <p className="mx-auto mb-8 max-w-2xl text-white/70">
                            Découvrez la beauté et la complicité du monde des chevaux en images.
                        </p>
                        <div className="aspect-video overflow-hidden rounded-lg border border-[#D4AF37]/30">
                            <iframe
                                className="h-full w-full"
                                src="https://www.youtube.com/embed/PEBktCYvcZc"
                                title="Le gars de la photo — Le monde équestre"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </section>

                {CATEGORIES.map((c, i) => (
                    <SpecialtySection key={c.id} {...c} index={i} />
                ))}
                <Creations />
                <PromoAutomne />
                <Tarifs />
                <Authenticite />
                <About />
                <AproposDeMoi />
                <Contact />
                                    <section className="relative overflow-hidden border-t border-[#D4AF37]/20 bg-gradient-to-b from-[#111111] to-[#050505] px-6 py-20 text-center">
                    <div className="mx-auto max-w-3xl">
                        <div className="mb-6 flex justify-center">
                            <div className="flex h-20 w-20 items-center justify-center rounded-full border border-[#D4AF37]/60 bg-[#D4AF37]/10">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="38"
                                    height="38"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#D4AF37"
                                    strokeWidth="1.4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden="true"
                                >
                                    <path d="M14 4h-4L8 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-4z" />
                                    <circle cx="12" cy="13" r="3.5" />
                                </svg>
                            </div>
                        </div>

                        <p className="mb-3 font-mono-lux text-xs tracking-[0.3em] text-[#D4AF37]">
                            AFTERSHOOT GALLERY
                        </p>

                        <h2 className="mb-5 text-2xl font-light tracking-[0.12em] text-white md:text-4xl">
                            MES GALERIES PHOTO
                        </h2>

                        <p className="mx-auto mb-9 max-w-xl text-sm leading-7 text-white/70 md:text-base">
                            Découvrez mes collections de photos : chevaux, animaux,
                            nature, paysages, portraits et bien plus encore.
                            Chaque image raconte une histoire.
                        </p>

                        <a
                            href="https://danphotographemariage.gallery.aftershoot.com/collection/toute-mes-collections-shooting-photos"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center gap-3 border border-[#D4AF37] bg-gradient-to-r from-[#9A7B38] via-[#D4AF37] to-[#9A7B38] px-8 py-4 font-mono-lux text-xs tracking-[0.18em] text-[#050505] transition-all duration-500 hover:shadow-[0_0_45px_rgba(212,175,55,0.35)]"
                        >
                            DÉCOUVRIR MES GALERIES
                            <span aria-hidden="true">↗</span>
                        </a>
                    </div>
                </section>
            </main>
            <Footer onBackToTop={() => scrollTo(0)} />
        </div>
    );
}

export default App;
